export { default as PixContent } from './PixContent';
